import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import BottomNav from "../../components/BottomNav";
import HomeCarpet from "./components/HomeCarpet";
import { RootState } from "../../redux/store";
import { COMPLETE_QUESTIONS, EDIT_PROFILE } from "../../navigation/Constants";
import { setAnswerCompletionQuestions } from "../../redux/app";
import { SELECT_MOOD } from "./../../navigation/Constants";
import { HomeScreenType } from "../../helpers/Enums";
import { Link } from "react-router-dom";
import NiceModal from "@ebay/nice-modal-react";
import DesktopNav from "../../components/DesktopNav";
import { setProfileMemberData } from "../../redux/profileMember";
import {
  getMemberPremiumStatus,
  getMemberRequiredProfileVerificationAndBlockedStatus,
  getMyMemberDetails,
  savePremiumStatusToMember,
} from "../../services/memberService";
import { setUserData } from "../../redux/member";
import usePrepareLink from "../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../const/router";
import { getGetCustomPopUp } from "../../services/appSettingService";
import { CustomPopUp } from "../../typings/customPopUp";
import parse from "html-react-parser";
import { addValueToCookie, isValueInCookie } from "../../helpers/CookieHandler";

export function HomeView() {
  let history = useHistory();
  const dispatch = useDispatch();
  const [showHome, setShowHome] = useState<boolean>(false);
  const member = useSelector((state: RootState) => state.member);
  const appSettings = useSelector((state: RootState) => state.app);
  const profileMember = useSelector((state: RootState) => state.profileMember);

  const freePremiumCities = ["חיפה"];
  // const freePremiumCities = ["חיפה", "קרית ביאליק"];

  const getPremiumStatus = async () => {
    try {
      const { data: status }: any = await getMemberPremiumStatus();
      return status;
    } catch (ex) {
      return true;
    }
  };

  const parseILDate = (dateStr: string): Date => {
    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day);
  };

  useEffect(() => {
    if (appSettings.openMoodSelect) {
      history.push(SELECT_MOOD);
      return;
    }

    setShowHome(true);

    // Created to address the issue of users remaining logged in for extended periods, leading to the inability to promptly block their access to the platform.
    getMemberRequiredProfileVerificationAndBlockedStatus()
      .then((response) => {
        const isRequiredVerificationOrBlocked = response.data;
        if (isRequiredVerificationOrBlocked) {
          getMyMemberDetails(member.memberCode)
            .then((response) => {
              dispatch(setUserData(response.data));
            })
            .catch((error) => {
              console.log("error in fetching user data");
              console.error("Error:", error);
            });
        }
      })
      .catch((error) => {
        console.log("error in checking user verification status");
        console.error("Error:", error);
      });

    return () => setShowHome(false);
  }, []);

  useEffect(() => {
    const fetchPopUpData = async () => {
      try {
        // console.log("****CCCCCCCC****");

        const trimmedMemberCity = member.city.trim();

        // console.log({
        //   trimmedMemberCity,
        //   subscriptionExpiryDate: member.subscriptionExpiryDate,
        // });

        // console.log(
        //   "parseILDate(member.subscriptionExpiryDate)",
        //   parseILDate(member.subscriptionExpiryDate || ""),
        // );

        // console.log("new Date()", new Date());

        if (
          (!member.isPremium ||
            (member.subscriptionExpiryDate &&
              parseILDate(member.subscriptionExpiryDate) < new Date())) &&
          freePremiumCities.includes(trimmedMemberCity)
        ) {
          // console.log({ member });
          // console.log("33333333");

          showStaticPopUpsCitySpecial(trimmedMemberCity);
        }

        const { data: popUpData }: { data: CustomPopUp } =
          await getGetCustomPopUp();

        //is there an active popup

        if (popUpData.isActive === undefined) {
          showStaticPopUps();
        } else {
          //has member seen this popup
          if (isValueInCookie("_popUpCancelledId", popUpData.id.toString())) {
            showStaticPopUps();
          } else {
            //is it meant for everyone or just free members
            if (popUpData.isShowToEveryone) {
              showCustomPopUp(popUpData);
            } else {
              //only free members supposed to see the popup
              const isPremium = await getPremiumStatus();
              if (isPremium) {
                showStaticPopUps();
              } else {
                showCustomPopUp(popUpData);
              }
            }
          }
        }
      } catch (ex) {
        showStaticPopUps();
        console.log(ex);
      }
    };
    fetchPopUpData();
  }, []);

  // useEffect(() => {
  //   const fetchPopUpData = async () => {
  //     try {
  //       const { data: popUpData }: { data: CustomPopUp } =
  //         await getGetCustomPopUp();
  //       //is there an active popup
  //       if (popUpData.isActive === undefined) {
  //         showStaticPopUps();
  //       } else {
  //         //has member seen this popup
  //         if (isValueInCookie("_popUpCancelledId", popUpData.id.toString())) {
  //           showStaticPopUps();
  //         } else {
  //           //is it meant for everyone or just free members
  //           if (popUpData.isShowToEveryone) {
  //             showCustomPopUp(popUpData);
  //           } else {
  //             //only free members supposed to see the popup
  //             const isPremium = await getPremiumStatus();
  //             if (isPremium) {
  //               showStaticPopUps();
  //             } else {
  //               showCustomPopUp(popUpData);
  //             }
  //           }
  //         }
  //       }
  //     } catch (ex) {
  //       showStaticPopUps();
  //       console.log(ex);
  //     }
  //   };
  //   fetchPopUpData();
  // }, []);

  // const closeCompleteQuestionModal = () => {
  //     setOpen(false);
  //     dispatch(setAnswerCompletionQuestions(true));
  // }

  const startCompleteQuestion = () => {
    history.replace(COMPLETE_QUESTIONS);
  };

  const showCustomPopUp = (data: CustomPopUp) => {
    NiceModal.show("action_modal", {
      onNext: () => {
        // addValueToCookie("_popUpCancelledId", data.id.toString());
        NiceModal.hide("action_modal");
      },
      headerTitle: data.title,
      contentTitle: (
        <div style={{ textAlign: "start" }}>{parse(data.content)}</div>
      ),
      primaryButtonText: data.closeButtonText,
      showCloseButton: true,
      showSeconderyButton: true,
      isDeleteModal: true,
      id: data.id.toString(),
    });
  };

  const showStaticPopUpsCitySpecial = (selectedCity: string) => {
    const dateEnd = new Date(new Date().getFullYear(), 11, 31);
    // const dateEnd = new Date();
    // dateEnd.setMonth(dateEnd.getMonth() + 1);

    const formattedDateEnd = new Intl.DateTimeFormat("en-GB").format(dateEnd);

    const freePremiumEndDateILFormat = dateEnd.toLocaleDateString("he-IL");

    // console.log({ dateEnd });
    // console.log("Current formattedDate:", formattedDate);
    // console.log(
    //   "Current member.subscriptionExpiryDate: ",
    //   member.subscriptionExpiryDate,
    // );

    NiceModal.show("action_modal", {
      onNext: async () => {
        //TODO: add service to call the
        const { data } = await savePremiumStatusToMember(
          member.memberCode,
          dateEnd,
          false,
        );
        const { isSuccess } = data;
        console.log({ isSuccess });

        if (isSuccess) {
          dispatch(
            setUserData({
              ...member,
              subscriptionExpiryDate: formattedDateEnd,
            }),
          );

          NiceModal.show("action_modal", {
            onNext: () => {
              // NiceModal.hide("action_modal");
              history.push({
                pathname: "/myProfile",
                search: "?popup=premiumPlanDetails",
              });
            },

            headerTitle: `ברכותינו!`,
            contentTitle: (
              <div style={{ textAlign: "center", padding: "0 20px" }}>
                <h2
                  style={{ margin: "0", textAlign: "center", fontSize: "24px" }}
                >
                  מנוי הפרימיום שלך בתוקף עד {freePremiumEndDateILFormat}!
                </h2>
                <p
                  style={{
                    lineHeight: "1.5",
                    textAlign: "center",
                    marginTop: "20px",
                    fontSize: "20px",
                  }}
                >
                  אנחנו שמחים שהצטרפת למנוי הפרימיום ומאחלים לך חווית היכרות
                  מהנה ומוצלחת בשושק'ה!
                </p>
              </div>
            ),
            primaryButtonText: "תודה רבה!",
            showCloseButton: true,
            showSeconderyButton: false,
          });
        }
      },

      onCancel: () => {
        NiceModal.hide("action_modal");
      },

      image: "/assets/images/milab_logo.png",
      // headerTitle: "מנוי פרימיום", // כותרת קצרה

      contentTitle: (
        <div style={{ textAlign: "center", padding: "0 20px" }}>
          <h2
            style={{
              margin: "0",
              textAlign: "center",
            }}
          >
            תושבי {selectedCity} הוותיקים -
          </h2>
          <h2
            style={{
              padding: "0",
              margin: "0",
              marginTop: "10px",
              marginBottom: "30px",
              textAlign: "center",
            }}
          >
            ההטבה שלכם מחכה לכם!
          </h2>
          <div style={{ direction: "rtl", fontSize: "22px" }}>
            <p
              style={{
                lineHeight: "1.8",
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              במילב דואגים לאיכות החיים שלך ומעניקים לך מנוי פרימיום לשושק'ה ללא
              עלות! כי בעיר שלנו הקשרים, החברות והאהבה ממשיכים לפרוח בכל גיל.
            </p>
            <p style={{ lineHeight: "1.8", textAlign: "center" }}>
              זה הזמן להכיר, לשוחח, להתרגש ולגלות חיבורים חדשים, עם הכלים
              המתקדמים של מנוי פרימיום, המוגש לך ללא עלות וללא כל התחייבות עד
              סוף שנת 2026!
            </p>
          </div>
        </div>
      ),
      primaryButtonText: "אני רוצה להינות מההטבה >>",

      // primaryButtonStyle: {
      //   background:
      //     "linear-gradient(182deg, rgb(200 255 169) 0%, rgb(69 151 24) 100%)",

      //   // background: "linear-gradient(135deg, #6fbc44 0%, #5aa033 100%)",
      //   borderRadius: "50px",
      //   boxShadow:
      //     "rgb(129 227 74 / 60%) 0px 0px 25px, rgba(111, 188, 68, 0.3) 0px 4px 15px",
      //   // boxShadow:
      //   //   "0 0 25px rgba(111, 188, 68, 0.6), 0 4px 15px rgba(111, 188, 68, 0.3)",
      //   border: "none",
      //   cursor: "pointer",
      //   transition: "all 0.3s ease",
      //   color: "black",
      // },

      secondaryButtonText: "לא עכשיו",
      showSeconderyButton: true,
      showCloseButton: true,
    });
  };

  const showStaticPopUps = () => {
    const trimmedMemberCity = member.city.trim();

    // אם תושב חיפה בלי פרימיום, לא להציג popup של תמונה
    if (
      (!member.isPremium ||
        (member.subscriptionExpiryDate &&
          parseILDate(member.subscriptionExpiryDate) < new Date())) &&
      freePremiumCities.includes(trimmedMemberCity)
    ) {
      // console.log("44444444");
      return;
    }

    if (
      member.shouldGetAccountsCompletionQuestions &&
      member.profilePicture !== null
    ) {
      if (!appSettings.answerCompletionQuestions) handleCompleteQuestion();
    } else {
      if (
        member.profilePicture === null &&
        profileMember.showNoProfilePictureModal
      ) {
        dispatch(setProfileMemberData({ showNoProfilePictureModal: false }));
        NiceModal.show("action_modal", {
          onNext: () => {
            NiceModal.hide("action_modal");
          },
          headerTitle: `שלום ${member.nickName}, לתשומת לבך:`,
          contentTitle: (
            <div style={{ textAlign: "start" }}>
              <p>
                החברים בשושק'ה לא יכולים לראות את הפרופיל שלך ולהציע לך הצעות
                היכרות כיוון שאין לך תמונת פרופיל.
              </p>
              <p>
                אפשר להעלות בקלות תמונה בלחיצה{" "}
                <Link to={EDIT_PROFILE}>כאן</Link>
              </p>
              <p>
                לסיוע טכני, אפשר{" "}
                <a
                  href="https://www.youtube.com/watch?v=Il7eWSCp4vg"
                  target="_blank"
                >
                  לצפות בסרטון
                </a>{" "}
                המסביר כיצד להעלות תמונת פרופיל או{" "}
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd1-u3uZRhU-XUZQ2fqTHl4o_sSvR3V09eMzSN7JwASulFxFA/viewform"
                  target="_blank"
                >
                  {" "}
                  להשאיר פרטים לסיירת התמיכה
                </a>{" "}
                לחזרה טלפונית
              </p>
            </div>
          ),
          primaryButtonText: "לא הפעם",
          showCloseButton: true,
          showSeconderyButton: true,
          isDeleteModal: true,
        });
      }
    }
  };

  // const showStaticPopUps = () => {
  //   if (
  //     member.shouldGetAccountsCompletionQuestions &&
  //     member.profilePicture !== null
  //   ) {
  //     if (!appSettings.answerCompletionQuestions) handleCompleteQuestion();
  //   } else {
  //     if (
  //       member.profilePicture === null &&
  //       profileMember.showNoProfilePictureModal
  //     ) {
  //       dispatch(setProfileMemberData({ showNoProfilePictureModal: false }));
  //       NiceModal.show("action_modal", {
  //         onNext: () => {
  //           NiceModal.hide("action_modal");
  //         },
  //         headerTitle: `שלום ${member.nickName}, לתשומת לבך:`,
  //         contentTitle: (
  //           <div style={{ textAlign: "start" }}>
  //             <p>
  //               החברים בשושק'ה לא יכולים לראות את הפרופיל שלך ולהציע לך הצעות
  //               היכרות כיוון שאין לך תמונת פרופיל.
  //             </p>
  //             <p>
  //               אפשר להעלות בקלות תמונה בלחיצה{" "}
  //               <Link to={EDIT_PROFILE}>כאן</Link>
  //             </p>
  //             <p>
  //               לסיוע טכני, אפשר{" "}
  //               <a
  //                 href="https://www.youtube.com/watch?v=Il7eWSCp4vg"
  //                 target="_blank"
  //               >
  //                 לצפות בסרטון
  //               </a>{" "}
  //               המסביר כיצד להעלות תמונת פרופיל או{" "}
  //               <a
  //                 href="https://docs.google.com/forms/d/e/1FAIpQLSd1-u3uZRhU-XUZQ2fqTHl4o_sSvR3V09eMzSN7JwASulFxFA/viewform"
  //                 target="_blank"
  //               >
  //                 {" "}
  //                 להשאיר פרטים לסיירת התמיכה
  //               </a>{" "}
  //               לחזרה טלפונית
  //             </p>
  //           </div>
  //         ),
  //         primaryButtonText: "לא הפעם",
  //         showCloseButton: true,
  //         showSeconderyButton: true,
  //         isDeleteModal: true,
  //       });
  //     }
  //   }
  // };

  const handleCompleteQuestion = () => {
    dispatch(setAnswerCompletionQuestions(true));
    NiceModal.show("action_modal", {
      onNext: startCompleteQuestion,
      headerTitle: ` ${member.nickName + ","} טוב לראות אותך כאן!`,
      contentTitle:
        "כדי שנוכל להציג לך אנשים שמתאימים לך בדיוק, נשאל אותך עכשיו כמה שאלות.",
      seconderyButtonText: "אשלים את הפרטים אחר כך",
      primaryButtonText: "בואו נתחיל",
      showCloseButton: true,
      showSeconderyButton: true,
      isWelcomeModal: true,
    });
  };

  return (
    <>
      {!showHome ? null : (
        <div>
          <HomeCarpet />
          <DesktopNav screenType={HomeScreenType.HOME} />
          <BottomNav screenType={HomeScreenType.HOME} />
        </div>
      )}
    </>
  );
}
